<template>
  <bvue-ui-view :scroll="true">
    <div class="w-full flex">
      <button @click="$router.go(-1); $store.commit('setBigMap', true)" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>{{ $t('volver') }}</label>
      </button>
      <div class="block flex w-full mb-4 justify-end mr-4">
        <!--<h1 class="flex-1 mb-0">{{ $t('perfil') }}</h1>-->
        <!-- IF mine: logout -->
        <button v-if="isMe" class="link flex items-center" @click="logout">
          <i class="material-icons">subdirectory_arrow_right</i>
          <label>{{ $t('cerrar') }}</label>
        </button>
      </div>
    </div>
    <div class="profile mb-8">
      <div class="block flex w-full">
        <div class="flex-1 ">
          <div class="sm:flex mt-2 ">
            <div class="flex flex-1 items-top mr-4 mb-4">
              <div class="w-full flex justify-center flex-col">
                <center>
                  <img :src="avatar(profile)" class="avatar avatar-xl">
                  <div class="flex flex-col ml-2 labels truncate mt-6">
                    <label class="text-xl userName truncate">{{profile.name}}</label>
                    <label class="text-sm  userTrees truncate">{{trees}} {{trees == 1 ?  $t('arbol')  : $t('arboles')}}</label>
                  </div>
                  <button v-if="isMe && trees !== 0" class="btn btn-primary flex mt-3" @click="printCertificate"> {{ $t('imprimircertificado') }}</button>  
                </center>
              </div>
              <div id="boton-editar" class="flex justify-end sm:flex" >
                <!-- IF mine: edit -->
                <button v-if="isMe" class="link items-center " @click="editProfile">
                <label>{{ $t('editar') }}</label></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="flex chip infoChip mt-2 items-center">
        <label class="chipLabel truncate">CO2 Neutralizado</label>
        <div class="flex-1 justify-end flex">
          <div class="flex truncate">
            <label>{{allCo2()}} mmHg</label>
          </div>
        </div>
      </div> -->
    </div>
    <div v-for="reserve in reserves" :key="reserve.id" class="mySeeds px-4 my-2">
      <div class="my-4 pb-4 md:flex w-full bottomLine">
        <div class="flex-1">
          <label class="block text-xs flex-1 mb-4"> {{ $t('misarboles') }} {{reserve.name.toUpperCase()}} </label>
          <!--<button class="link md:mt-4 mb-4 flex items-center" @click="showInMap(reserve.id)">
            <i class="material-icons mr-2">map</i>
            <label>{{ $t('vermapa') }}</label>
            </button>-->
        </div>
         <!-- IF mine: seeds -->
        <div v-if="isMe" class="md:px-4 items-center leftLine">
          <div class="flex-1 flex mb-2">
            <label class="block grey-text text-xs flex-1"> {{ $t('semillas') }} </label>
            <div class="flex">
              <div class="menu-badge seedBox rounded-full px-2 flex justify-center">
                <img :src="require('@/assets/images/seed.svg')" class="seedImg ">
                <label class="base-text ml-1"> {{$store.getters.reserveUserSeeds(reserve.id).length}} </label>
              </div>
            </div>
          </div>
          <div class="items-center w-full mt-3" v-if="vownSeeds>5">
            <button class="btn btn-primary" @click="autoPlantTrees(reserve.id)"> {{ $t('semillasaleatoriasboton') }} </button>
          </div>
          <div class="flex items-center w-full mt-2"  v-if="vownSeeds<6">
            <button class="btn btn-primary w-full mt-2" @click="buySeeds(reserve.id)"> {{ $t('donar') }} </button>
          </div>
          <div id="alerta" class="mt-3 grey-text" v-if="vownSeeds>1">
            <b><center> {{ $t('semillasaleatoriastexto') }} </center></b>
          </div>
        </div>
      </div>
      <div v-for="tree in reserve.plantedTrees" :key="tree.id" class="treeCell my-4 flex-col">
        <div class="flex">
          <label class="flex-1 grey-text specieName truncate">{{$store.state.species.items[tree.specie].name}}</label>
          <div class="flex-1">
            <label class="block grey-text text-xs justify-end text-right">{{formattedDate(tree.planted.date)}}</label>
          </div>
        </div>
        <div class="md:flex items-center">
          <label class="plantLoc truncate flex-1">{{tree.position.lat.toFixed(8)}}, {{tree.position.lng.toFixed(8)}}</label>
          <div class="flex flex-1 items-center truncate">
            <!-- <div class="flex chip infoChip mt-2 items-center truncate">
              <label class="chipLabel flex truncate">CO2 contrarrestado</label>
              <div class="flex-1 justify-end flex">
                <div class="flex justify-end truncate">
                  <label class="truncate">{{co2(tree)}} mmHg</label>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </bvue-ui-view>
</template>


<script>
import { mapGetters } from 'vuex'
import { co2ofTree } from '@/utils/tree'
import ProfileEditorModal from '@/components/ProfileEditorModal'
import BuySeeds from '@/components/modals/BuySeeds'
import firebase from '@/firebase'
export default {
  name: 'Profile',
  components: {
    ProfileEditorModal
  },
  mounted() {
    this.$ga.page('/Perfil');
  },
  data() {
    return {
      vseeds: '',
      profileWatchInitialized: false
    }
  },
  computed: {
    isMe() {
      return !this.$route.params.id && !!this.$store.state.auth.user
    },
    vownSeeds(){
      var reserves = this.$store.getters.activeReserves
      if (!reserves || reserves.length === 0) return 0
      var reservaid = reserves[0].id
      var ownSeeds = this.$store.getters.userSeeds(reservaid)
      return ownSeeds.length
    },
    reserves() {
      var response = []
      if (this.userId) {
        const reserves = this.$store.getters.activeReserves
        reserves.forEach(reserve => {
          var responseReserve = {...reserve}
          responseReserve.plantedTrees = []
          for (const seedId in reserve.seeds) {
            const seed = reserve.seeds[seedId];
            if (seed.planted && seed.planted.ownerId == this.userId) {
              var plantedTree = reserve.trees[seed.planted.treeId]
              plantedTree.planted = seed.planted
              responseReserve.plantedTrees.push(plantedTree)
            }
          }
          if (responseReserve.plantedTrees.length > 0) {
            response.push(responseReserve)
          }
        });
      }      
      return response
    },
    userId() {
      var userId = this.$route.params.id
      if (!userId && this.$store.state.auth.user) {
        userId = this.$store.state.auth.user.uid
      } 
      return userId
    },
    email(){
      var currentUser = firebase.auth.currentUser
      return currentUser ? currentUser.email : ''
    },
    profile() {
      if (this.userId) {
        var persona = {email: this.email, password: '', newemail: ''}
        var response = this.$store.state.profiles[this.userId]
        let profile = Object.assign({}, response, persona)

        return profile || {}
      }
      return {}
    },
    trees() {
      if (this.userId) {
        return this.$store.getters.userTrees(this.userId)
      }
      return 0
    },
  },
  watch: {
    userId: {
      handler(id) {
        if (id) {
          this.$store.dispatch('profiles/updateProfile', id)
        }
      },
      immediate: true
    }
  },
  methods: {
    async autoPlantTrees(reserveId){
      const userId = this.$store.state.auth.user && this.$store.state.auth.user.uid
      if (!userId) {
        return
      }
      const response = await this.$dialogs.alert(this.$t('semillasaleatoriasmodaltexto'), {title: this.$t('semillasaleatoriasmodaltitulo'), okLabel: this.$t('semillasaleatoriasmodalboton')})
      if (!response.ok) {
        return
      }
      // Datos desde el store (suscripciones onSnapshot ya activas): sin lecturas extra a Firestore
      const reserve = this.$store.state.reserves.items[reserveId]
      if (!reserve || !reserve.trees || !reserve.seeds) {
        return
      }
      const mySeeds = this.$store.getters.reserveUserSeeds(reserveId)
      const plantedTreeIds = {}
      for (const key in reserve.seeds) {
        const seed = reserve.seeds[key]
        if (seed.planted) {
          plantedTreeIds[seed.planted.treeId] = true
        }
      }
      const freeTrees = Object.keys(reserve.trees).filter(treeId => !plantedTreeIds[treeId])
      // Mezcla aleatoria (Fisher-Yates) para repartir las semillas en árboles al azar
      for (let i = freeTrees.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const tmp = freeTrees[i]
        freeTrees[i] = freeTrees[j]
        freeTrees[j] = tmp
      }
      const count = Math.min(mySeeds.length, freeTrees.length)
      if (count === 0) {
        this.$dialogs.alert('No hay árboles disponibles en esta reserva por el momento.', {title: this.$t('semillasaleatoriasmodaltitulo'), okLabel: 'Ok'})
        return
      }
      const updates = []
      for (let i = 0; i < count; i++) {
        const planted = {
          date: new Date().getTime(),
          ownerId: userId,
          treeId: freeTrees[i]
        }
        updates.push(firebase.firestore.collection('reserves').doc(reserveId).collection('seeds').doc(mySeeds[i].id).update({planted: planted}))
      }
      try {
        await Promise.all(updates)
        await this.$dialogs.alert('Tus semillas han sido plantadas exitosamente. Gracias por reforestar con Árbola.', {title: this.$t('semillasaleatoriastexto'), okLabel: 'Continuar'} )
      } catch (err) {
        console.error('autoPlantTrees error: ', err)
        this.$dialogs.alert('No se pudieron plantar todas las semillas, vuelve a intentarlo.', {title: 'Error', okLabel: 'Ok'})
      }
    },
    async logout() {
      const response = await this.$dialogs.alert(this.$t('segurocerrar'), {title: this.$t('cerrarsesion') , okLabel: this.$t('cerrarsesion')} )
      if (response.ok) {
        this.$store.dispatch('auth/logout')
        this.$router.go(-1)
      }
    },
    avatar(profile) {
      return profile.image || require('@/assets/images/profile.svg')
    },
    formattedDate(timeStamp) {
      const date = new Date(timeStamp)
      return date.toLocaleDateString()
    },
    editProfile() {
      this.$bvueUi.modal.show({
        component: ProfileEditorModal,
        width: 600,
        height: 500,
        data: this.profile
      })
    },
    co2(tree) {
      return co2ofTree(tree)
    },
    allCo2() {
      var response = 0
      if (this.reserves) {
        this.reserves.forEach(reserve => {
          reserve.plantedTrees.forEach(tree => {
            response += co2ofTree(tree)
          });
        });
      }
      return response
    },
    showInMap(reserveId) {
      this.$router.push(`/map/${reserveId}/${this.userId}`)
    },
    buySeeds(reserveId) {
      console.log('reserveId:', reserveId)
      this.$bvueUi.modal.show({
        component: BuySeeds,
        width: 600,
        height: 500,
        data: {
          reserveId: reserveId
        }
      })
    },
    async printCertificate() {
      console.log('Print certificate')
      var userId = this.$store.state.auth.user.uid
      const response = await this.$dialogs.alert(this.$t('perfilcertificadotexto') + ' '  + this.$t('perfilcertificadocorreo') + ' ' + this.$store.state.auth.user.email + '. '  + this.$t('perfilcertificadonombre') + ' ' + this.profile.name + '.', {title: this.$t('perfilcertificadoheader') , okLabel: this.$t('perfilcertificadoenviar')})
      if(response.ok && userId !== ''){  
        let template = {
          data: {
            plural: '',
            'user-name': this.profile.name,
            'tree-count': this.$store.getters.userTrees(this.userId)
          },
          name: ''
        }        
        if (this.$i18n.locale === 'es') {
          if(this.$store.getters.userTrees(this.userId) === 1) {
            template.data.plural = ''
          } else {
            template.data.plural = 'es'
          }
          template.name = 'certificateES'
        }
        if (this.$i18n.locale === 'en') {
          if(this.$store.getters.userTrees(this.userId) === 1) {
            template.data.plural = ''
          } else {
            template.data.plural = 's'
          }
          template.name = 'certificateEN'
        }
        if (this.$i18n.locale === 'de') {
          if(this.$store.getters.userTrees(this.userId) === 1) {
            template.data.plural = 'Baum'
          } else {
            template.data.plural = 'Bäume'
          }
          template.name = 'certificateDE'
        }
        await firebase.firestore.collection('mail').doc().set({template, to: this.$store.state.auth.user.email})
        
      }
    }
  }
}
</script>

<style scoped>

#boton-editar {
  min-width: 19%;
}

.link {
  max-height: 52px;
}

#alerta {
  max-width: 250px;
}

.avatar {
  width: 140px !important;
  height: 140px !important;
  border-radius: 100% !important;
  outline: 10px #d3eba1 solid;
}
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue